import React, { Component } from "react";
import SharedHelmet from "../Helmet";
import ramadanImg from "../../../images/ramadan.webp";
import eidAdhaImg from "../../../images/eid-adha.webp";
import eidFatrImg from "../../../images/eid-fatr.webp";
class Articles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "Miscellaneous",
      links: {
        technology: [
        ],
        health: [{}],
        women: [{}],
        Miscellaneous: [
          {
            id: 1,
            title: "Remaining Days until Ramadan 2026",
            url: "/articles-en/ramadan/",
            imageUrl: ramadanImg,
            description: "Discover the date of Ramadan 2026 now",
          },
          {
            id: 2,
            title: "Remaining Days until Eid al-Adha 2026",
            url: "/articles-en/eid-adha/",
            imageUrl: eidAdhaImg,
            description: "Discover the date of Eid al-Adha 2026 now",
          },
          {
            id: 3,
            title: "Remaining Days until Eid al-Fitr 2026",
            url: "/articles-en/eid-fatr/",
            imageUrl: eidFatrImg,
            description: "Discover the date of Eid al-Fitr 2026 now",
          },
        ],
      },
    };
  }
  handleTabClick = (tabName) => {
    this.setState({ activeTab: tabName });
  };
  render() {
    const TITLE = "Many Articles and Free Guest POST";
    const DESCRIPTION =
      "Explore the world of technology, health, money, women empowerment, beauty tips, and insights into Islam. Stay informed, healthy, and financially savvy while enhancing your lifestyle and spirituality";
    const KEYWORDS =
      "Explore the world of technology, health, money, women empowerment, beauty tips, and insights into Islam";
    const OG_URL = "https://do-calculate.com/articles-en/";
    const { activeTab, links } = this.state;
    const activeTabLinks = links[activeTab];
    const tabContainerStyle = {
      display: "flex",
      borderBottom: "1px solid #dee2e6",
    };
    const tabButtonStyle = {
      flex: 1,
      padding: "10px 15px",
      cursor: "pointer",
      border: "none",
      background: "#f8f9fa",
      color: "#495057",
      textAlign: "center",
      fontWeight: "500",
      borderRadius: "0.25rem",
      margin: "0",
      borderBottom: "2px solid transparent",
    };
    const tabButtonActiveStyle = {
      ...tabButtonStyle,
      background: "#ffffff",
      color: "#007bff",
      borderBottom: "2px solid #007bff",
    };
    const tabContentStyle = {
      padding: "15px",
      borderTop: "1px solid #dee2e6",
    };
    const availableTabs = Object.keys(links)
      .filter((tab) => links[tab] && links[tab].some((article) => article.id))
      .map((tabName) => {
        if (tabName === "technology") {
          return "تكنولوجيا";
        }
        return tabName;
      });
    return (
      <div className="rtl">
        <SharedHelmet
          TITLE={TITLE}
          DESCRIPTION={DESCRIPTION}
          KEYWORDS={KEYWORDS}
          OG_URL={OG_URL}
        />
        <div className="bg-success text-white" role="alert">
          {DESCRIPTION}.
          <div className="text-center">
          </div>
        </div>
        <hr />
        <section id="tabs">
          <div style={tabContainerStyle}>
            {availableTabs.map((tabName) => (
              <button
                key={tabName}
                style={
                  activeTab === tabName ? tabButtonActiveStyle : tabButtonStyle
                }
                onClick={() => this.handleTabClick(tabName)}
              >
                {tabName.charAt(0).toUpperCase() + tabName.slice(1)}
              </button>
            ))}
          </div>
        </section>
        {activeTabLinks && activeTabLinks.length > 0 && (
          <section id="gallery" style={tabContentStyle}>
            <div className="container">
              <div className="row">
                {activeTabLinks.map(
                  (link) =>
                    link.id && (
                      <div
                        key={link.id}
                        className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
                      >
                        <div className="card">
                          <img
                            src={link.imageUrl}
                            alt={link.title}
                            className="card-img-top"
                            style={{ width: "100%", height: "200px" }}
                          />
                          <div className="card-body">
                            <h5 className="card-title">{link.title}</h5>
                            <p className="card-text">{link.description}</p>
                            <a
                              href={link.url}
                              className="btn btn-outline-success btn-sm"
                            >
                              Read More{" "}
                            </a>
                          </div>
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          </section>
        )}
      </div>
    );
  }
}
export default Articles;
